import { ModalDialog, Dialog } from '@pelckmans/business-components/components/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../contexts/ModalContext';
import ModalLink from '../../../components/ModalLink';
import useRouting from '../../../hooks/useRouting';

type Props = {
  id: string;
  action: 'view' | 'access';
  license?: 'teacher';
};

export default function NotLicensedModuleModal({ id, action, license }: Props) {
  const { t } = useTranslation();
  const { r } = useRouting();

  const { closeModal } = useContext(ModalContext);

  const translationKey = `MODULES.MATERIAL.COMPONENTS.MODALS.NOT_LICENSED.${action.toUpperCase()}_CONTENT`;

  return (
    <ModalDialog
      id={id}
      closeTitle={t('ACTIONS.CLOSE')}
      closeOnClickOutside
      closeViaEscape
      onClose={() => closeModal(id)}
      size="small"
    >
      <Dialog.Header title={t(`${translationKey}.TITLE`)} />
      <Dialog.Body>
        <p className="p-no-margin-bottom">
          {action === 'view' && license ? t(`${translationKey}.MESSAGE-TEACHER`) : t(`${translationKey}.MESSAGE`)}
        </p>
      </Dialog.Body>
      <Dialog.Footer>
        <ModalLink
          id={id}
          to={`${r('dashboard')}?showLicenseActivation`}
          className="bc-button__button bc-button__primary bc-button__small"
        >
          {t(`${translationKey}.ACTIONS.ACTIVATE_LICENSE`)}
        </ModalLink>
      </Dialog.Footer>
    </ModalDialog>
  );
}
